import { useLanguage } from './language-context.js';
import content from './content.js';

const Nav = ({ visible, activeSection }) => {
  const { lang, toggleLang } = useLanguage();
  const t = content[lang].nav;

  return (
    <nav className={`site-nav${visible ? ' site-nav-visible' : ''}`}>
      <a className="site-nav-mark" href="#top">RQ</a>
      <div className="site-nav-right">
        <ul className="site-nav-links">
          {t.links.map((link) => {
            const isActive = link.href === `#${activeSection}`;
            return (
              <li key={link.href}>
                <a href={link.href} className={isActive ? 'active' : undefined}>{link.label}</a>
              </li>
            );
          })}
        </ul>
        <button type="button" className="lang-toggle" onClick={toggleLang} aria-label="Switch language">
          {t.toggleLabel}
        </button>
      </div>
    </nav>
  );
}

export default Nav;
